import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import {
  FETCH_FLEET_RESERVATIONS,
  GET_FLEET_RESERVATION,
  CHECK_FLEET_RESERVATION_AVAILABILITY,
  CREATE_FLEET_RESERVATION,
  RESCHEDULE_FLEET_RESERVATION,
  CANCEL_FLEET_RESERVATION,
} from 'actions/fleetReservation';

const createWorker = (actionType, apiFn) =>
  function* worker(action) {
    try {
      const response = yield call(apiFn, action.payload);
      yield put({ type: actionType.SUCCESS, payload: response.data });
      action.cb && action.cb(response);
    } catch (e) {
      yield put({ type: actionType.FAIL, payload: { error: e } });
      action.cb && action.cb(e);
    }
  };

function* fleetReservation() {
  yield takeLatest(FETCH_FLEET_RESERVATIONS.REQUEST, createWorker(FETCH_FLEET_RESERVATIONS, API.getFleetReservations));
  yield takeLatest(GET_FLEET_RESERVATION.REQUEST, createWorker(GET_FLEET_RESERVATION, API.getFleetReservation));
  yield takeLatest(
    CHECK_FLEET_RESERVATION_AVAILABILITY.REQUEST,
    createWorker(CHECK_FLEET_RESERVATION_AVAILABILITY, API.checkFleetReservationAvailability)
  );
  yield takeLatest(CREATE_FLEET_RESERVATION.REQUEST, createWorker(CREATE_FLEET_RESERVATION, API.createFleetReservation));
  yield takeLatest(RESCHEDULE_FLEET_RESERVATION.REQUEST, createWorker(RESCHEDULE_FLEET_RESERVATION, API.rescheduleFleetReservation));
  yield takeLatest(CANCEL_FLEET_RESERVATION.REQUEST, createWorker(CANCEL_FLEET_RESERVATION, API.cancelFleetReservation));
}

export default fleetReservation;
